import React from 'react'
import ReactLoading from 'react-loading';

const Loading = () => {
  return (
    <ReactLoading type={"cubes"} color={"#fff"} height={'20px'} width={'20px'} />
  )
}

export default Loading